export enum SceneDefinitionSettingsControl {
    EARTH = "EARTH",
    ORBIT = "ORBIT",
    FPS = "FPS",
    CONSTRAINED = "CONSTRAINED",
}
